import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as l, normalizeClass as n, createElementVNode as r } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconTimerReset",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.5 1A.5.5 0 0 1 5 .5h2a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM6 4.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
}, null, -1), m = /* @__PURE__ */ r("path", {
  d: "M5.996 3.5a3.5 3.5 0 0 0-3.5 3.062.5.5 0 0 1-.992-.124A4.5 4.5 0 0 1 6.002 2.5a4.5 4.5 0 1 1-2.983 7.875l-.001-.001-.518-.46v1.385a.5.5 0 1 1-1 0v-2.5a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 0 1H3.314l.367.326a3.504 3.504 0 0 0 4.638-.008A3.5 3.5 0 0 0 6 3.5h-.003Z",
  fill: "currentColor"
}, null, -1), u = [
  _,
  m
];
function h(a, f, i, p, v, e) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--timer-reset"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Timer Reset",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const I = /* @__PURE__ */ o(s, [["render", h]]);
export {
  I as default
};
//# sourceMappingURL=timer-reset.js.map
